module.exports = __webpack_public_path__ + "img/popup-close-black.e84dc144.svg";